var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 12.6667H5.33341C2.66675 12.6667 1.33341 12 1.33341 9.33334V5.33334C1.33341 2.66667 2.66675 1.33334 5.33341 1.33334H10.6667C13.3334 1.33334 14.6667 2.66667 14.6667 5.33334V9.33334C14.6667 12 13.3334 13.3333 10.6667 13.3333H10.3334C10.1267 13.3333 9.92675 13.4333 9.80008 13.6L8.80008 14.9333C8.36008 15.52 7.64008 15.52 7.20008 14.9333L6.20008 13.6C6.09341 13.4533 5.84675 13.3333 5.66675 13.3333V12.6667Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 5.33334H11.3334",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 8.66666H8.66675",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageText);
export default __webpack_public_path__ + "static/media/message-text.b43a9364d05caeef601d72c50f93bf01.svg";
export { ForwardRef as ReactComponent };